import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { LazyMotion, domAnimation } from 'motion/react';

import App from './App.tsx';
import { Avisos } from './components/Avisos.tsx';
import './styles.css';

const raiz = document.getElementById('root');
if (!raiz) throw new Error('elemento #root nao encontrado');

createRoot(raiz).render(
  <StrictMode>
    {/*
      `LazyMotion` com `domAnimation` em vez do pacote completo. A
      diferença é de dezenas de kilobytes: a importação cheia traz layout
      animado, arraste e camada 3D, e este aplicativo anima duas
      sobreposições em opacidade e deslocamento. Peso de download num
      produto que abre no celular do jogador não é detalhe.

      O par disto são os componentes `m.` no lugar de `motion.` — usar
      `motion.` junto anularia o ganho, porque ele reintroduz tudo.
    */}
    <LazyMotion features={domAnimation} strict>
      <App />
    </LazyMotion>
    {/* Uma pilha de avisos para o aplicativo inteiro. Montada aqui, e
        nao dentro do App, porque o App tem varios `return` e um deles
        acabaria esquecido — dois avisos apareceriam em cantos
        diferentes da tela, ou nenhum apareceria. */}
    <Avisos />
  </StrictMode>,
);
